let error_template = `
{{#if show_as_dialog}}
<div class="modal-dialog modal-lg">
  <div class="modal-content">
  {{#if title}}
    <div class="modal-header">
      <span class="title">{{title}}</span>
  {{/if}}
      <button class="btn-close" data-dismiss="modal">X</button>
  {{#if title}}
    </div>
    <div class="modal-alert-container new">
      <div class="alert"></div>
    </div>
    <form>
{{/if}}
      <div class="modal-body">
{{/if}}
{{#if message}}
    <div class="message">{{message}}</div>
{{/if}}
        <label for="responses">Details</label>
        <div class="collection-table-form-wrapper">
          <table class="table" name="responses">
            <thead>
              <tr>
                <th>ID</th>
                <th>CODE</th>
                <th>STATUS</th>
                <th>TITLE</th>
                <th>DETAIL</th>
              </tr>
            </thead>
            {{#each messages}}
            <tr class="{{#if is_error}}danger{{/if}}{{#unless is_error}}success{{/unless}}">
              <td>{{id}}</td>
              <td>{{code}}</td>
              <td>{{status}}</td>
              <td>{{title}}</td>
              <td>{{detail}}
                {{#if source.pointer}}
                   <br>source: {{source.pointer}}
                {{/if}}
                {{#if meta}}
                  {{#each meta}}
                    {{#if text}}
                    <br>text: {{text}}
                    {{/if}}
                    {{#if file}}
                    <br>file: {{file}}
                    {{/if}}
                  {{/each}}
                {{/if}}
              </td>
            </tr>
            {{/each}}
          </table>
        </div>
      </div>
{{#if show_as_dialog}}
      <div class="modal-footer">
        <button type="button" class="btn btn-link cancel" data-dismiss="modal">Done</button>
      </div>
    </form>
  </div>
</div>
{{/if}}`;



/*
 *  response_results_view.js
 *
 *  Feed it to an api error resp object, and it
 *  will try to digest it into a table with filtering
 *  options.
 *
 *      new  ResponseResultsView({
 *          resp ; resp
 *      }
 *
 *  When we are iterating through a list, and making
 *  lots of requests (unassigning devices, for example),
 *  I wound up with an Array of messages, so, this also
 *  accept that and deal with it as well.
 */

import _ from 'underscore';
import Backbone from 'backbone';
import _Marionette from 'backbone.marionette';
import alert_mixin from '@/mixins/alert';
import Handlebars from 'handlebars';

    var view = Backbone.Marionette.View.extend(alert_mixin).extend({
        template: Handlebars.compile(error_template),
        ui: {
            title: '.title',
            info: '.info',
            response: '.response',
        },
        regions: {
            header: '@ui.header',
            response: '@ui.response',
            alerts: '@ui.alert'
        },
        events: {
            'click @ui.cancel': 'on_cancel'
        },
        templateContext: function() {
            var show_as_dialog = false;
            if ( _.isFunction(this.closeDialog) ){
                show_as_dialog = true;
           }

            // Assemble all of the error messages
            // together into an Object Array which is digested
            // in the template

            var messages = [];
            var resp = this.options.resp;
            var values = this.options.values;
            if ( resp && resp.responseJSON && resp.responseJSON.errors) {
                _.each(resp.responseJSON.errors, function(e){
                    // We only get pointer information from the API.
                    // If we need to tie results to particular things
                    // for example, device ids, then we need to have
                    // passed the values we made the request in as
                    // an option to this view.
                    if ( values ){
                        e.id = values[e.source.pointer.match(/\d+/)[0]];
                    }
                    // Seems we don't use this dialog for anything but error messages, right now.
                    // If that changes, can't do this.
                    e.is_error = true;
                    if ( e.detail && e.detail.message ) {
                        e.detail = e.detail.message;
                    }
                    messages.push(e);
                });
            } else if ( _.isArray(resp) ){
                // If this is an assembled list of errors, for
                // example, unassigning a group of devices, pointer
                // information will be tough, so, assign before
                // creating this view
                _.each(resp, function(e){
                    // Seems we don't use this dialog for anything but error messages, right now.
                    // If that changes, can't do this.
                    e.is_error = true;

                    messages.push(e);
                });
            } else if ( resp && resp.responseJSON && resp.responseJSON.error ) {
                messages.push({
                    is_error: true,
                    detail: resp.responseJSON.error
                });
            }

            return {
                 title: this.options.title || false,
                 show_as_dialog: show_as_dialog || false,
                 messages: messages,
                 message: this.options.message
            };
        }
    });

    export default view;

